"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IWallet_1 = require("../models/wallets/IWallet");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const validPaymentTypes = Object.values(IWallet_1.IPaymentType);
class PayInvoicesValidator extends GenericValidator_1.default {
    _payInvoicesSchema = joi_1.default.object({
        invoiceIds: joi_1.default.array().items(joi_1.default.string()).min(1).unique().required(),
        walletId: joi_1.default.string(),
        transaction: joi_1.default.object({
            transactionId: joi_1.default.string().required(),
            totalPaid: joi_1.default.number().required(),
            paymentType: joi_1.default.string()
                .valid(...validPaymentTypes)
                .required(),
            last4: joi_1.default.string().required(),
        }),
    })
        .xor('walletId', 'transaction')
        .required();
    validate(payInvoices) {
        super.validate(payInvoices, 'IPayInvoices', this._payInvoicesSchema);
    }
}
exports.default = PayInvoicesValidator;
